import { flatten, some, uniq, compact } from 'lodash-es';

import { Item, DocumentType } from 'components/organisms/publish/interfaces';

// API returns this error string format for unpublish package items that are
// used in assignments
const usedInAssignmentErrorRegex = /^validators\.unpublisher\.(course|bundle|topic|question)_error$/;
export const hasAssignmentError = 'validators.unpublisher.has_assignments';

export const hasContentsUsedInAssignments = (items: Item[]) => {
  const errors = flatten(items.map(i => i.errors));
  return some(errors, e => e.match(usedInAssignmentErrorRegex));
};

const getTopicNamesFromTopicAndQuestionItems = (items: Item[]) => {
  return items
    .filter(i =>
      [DocumentType.Topic, DocumentType.Question].includes(i.document_type),
    )
    .map(i => i.name || i.topic_name);
};

const getTopicNamesFromCourseAndBundleItems = (items: Item[]) => {
  const courseAndBundleItems = items.filter(i =>
    [DocumentType.Course, DocumentType.Bundle].includes(i.document_type),
  );

  // warnings are stringified JSONs that contain the error key and a name
  // example: "{"key":"validators.unpublisher.has_assignments","name":"Topic name"}"
  const warningObjects = flatten(courseAndBundleItems.map(i => i.warnings)).map(
    warning => {
      try {
        return JSON.parse(warning);
      } catch (e) {
        return {};
      }
    },
  );

  const topicNames = warningObjects.map(({ key, name }) => {
    if (key === hasAssignmentError) {
      return name;
    }
  });

  return compact(topicNames);
};

export const getTopicNamesUsedInAssignments = (items: Item[]) => {
  const itemsUsedInAssignment = items.filter(i =>
    some(i.errors, e => e.match(usedInAssignmentErrorRegex)),
  );

  const topicNames = [
    ...getTopicNamesFromTopicAndQuestionItems(itemsUsedInAssignment),
    ...getTopicNamesFromCourseAndBundleItems(itemsUsedInAssignment),
  ];

  return uniq(topicNames);
};
